/**
 * formats the array data
 *
 * @param {Array} data - array of banks/channels data
 * @returns {Object} - returns the foratted data object
 */
export const formatList = data => {
  if (!data) {
    data = [];
  }
  data = data.map(item => {
    return typeof item === 'string' ? { displayName: item } : item;
  });
  data = data.sort((first, second) => {
    return first.displayName.localeCompare(second.displayName);
  });

  return data;
};

/**
 * filters the banks/channels array corresponding to search value
 *
 * @param {Object} e - input onKeyUp event object
 * @param {Array} data - array of banks/channels
 * @returns {Object} - return the state data object with bank lists and search value
 */
export const filterList = (value, data) => {
  data = data.filter(item => {
    return item.displayName.toLowerCase().indexOf(value.toLowerCase()) !== -1;
  });
  return { listData: formatList(data), searchValue: value };
};

/**
 * Empty the search value ins state and resets the other banks data
 *
 * @param {Array} banks - array of banks/channels
 * @returns {Object} - returns  the state data object with the banks/channels array and empty searchValue
 */
export const clearSearch = banks => {
  return { listData: formatList(banks), searchValue: '' };
};



// WEBPACK FOOTER //
// ./controllers/select-ifsc.js